<template>
    <div ref="list" class="tw-divide-y tw-divide-gray-50 tw-divide-solid">
        <a
            v-for="learningPath in learningPaths.slice(0, maxAmountVisible)"
            :key="learningPath._id"
            class="tw-border-0 tw-py-4 tw-flex tw-items-center tw-justify-center"
            :class="{ 'tw-pv-0': learningPaths.length === 1 }"
            href="#/learning/library"
        >
            <div
                class="tw-flex-1 tw-text-gray-900 hover:tw-text-indigo-500 focus:tw-text-indigo-500"
            >
                {{ learningPath.name }}
                <div class="tw-text-gray-500">{{ learningPath.description }}</div>
            </div>
            <div class="tw-flex-grow-0">
                <l-base-button
                    :button-types="['primary']"
                    @click.native="onEnroll(learningPath.commonId)"
                >
                    {{ $t("learning.library.paths.enrol") }}
                </l-base-button>
            </div>
        </a>

        <l-user-profile-load-more
            :items="learningPaths"
            :value.sync="maxAmountVisible"
            :max-amount-visible="3"
            :scroll-to-element="$refs.list"
        />
    </div>
</template>

<script>
import LUserProfileLoadMore from "@/components/LUserProfile/LUserProfileLoadMore";
import LBaseButton from "@/components/LBaseButton";

export default {
    components: {
        LUserProfileLoadMore,
        LBaseButton,
    },
    props: {
        learningPaths: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            maxAmountVisible: 3,
        };
    },
    methods: {
        async onEnroll(pathCommonId) {
            const progress = await this.$store.dispatch({
                type: "learning/progress/selfenrol",
                payload: { pathCommonId },
            });

            this.$router.push(
                `/learning/progress/${progress?._id}/${progress.progressSteps?.[0]?._id}`,
            );
        },
    },
};
</script>
